// extracted by mini-css-extract-plugin
export default {"section":"DepositsSection_section__D37TB","kpis":"DepositsSection_kpis__iYLik","tableWrapper":"DepositsSection_tableWrapper__EnZmn"};